import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'fuse-ui/components/Snackbar';

import ReportProblemIcon from '@material-ui/icons/ReportProblem';

export const GeneralErrorSnackbar = ( { additionalOptions, open, onClose } ) => {

    const defaultSnackbarProps = {
        autoHideDuration: 8000,
        icon: <ReportProblemIcon/>,
        message: 'Oops! Something went wrong.',
        variant: 'error',
    };

    const snackbarProps = {
        ...defaultSnackbarProps,
        ...additionalOptions
    };

    return <Snackbar
        dataAutomationId="error-snackbar"
        open={open}
        onClose={onClose}
        actionCloseButton
        {...snackbarProps}
    />;
};

GeneralErrorSnackbar.propTypes = {
    additionalOptions: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default GeneralErrorSnackbar;
